import { render, staticRenderFns } from "./UserCreateDialog.vue?vue&type=template&id=157de189"
import script from "./UserCreateDialog.vue?vue&type=script&lang=js"
export * from "./UserCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports